import { render } from "./BingChatBotSettings.vue?vue&type=template&id=486ae740"
import script from "./BingChatBotSettings.vue?vue&type=script&lang=js"
export * from "./BingChatBotSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__